import { AdViewModel } from "./ad-view-model.model";
import { ContentViewModel } from "./content-view-model.model";

export class OrderViewModel {

	id!: string;
	orderNumber!: string
	bookedDate!: string
	startDate!: string
	endDate!: string
	campaignName!: string
	priceNetExTax!: number;
	priceNetIncTax!: number;
	paidAmount!: number;
	isCalculated: boolean = false;
	subscriberNumber?: string;

	adVM: AdViewModel;
	contentVM: ContentViewModel;

	constructor() {
		this.id = ""; // TBD: for new order only
		this.adVM = new AdViewModel();
		this.contentVM = new ContentViewModel();
	}
}
